import { AiGenerationMode } from '../constants/ai-modes.constants';
import { WizardStep } from '../constants/wizard-steps.constants';

export interface WorldEra {
  type: 'Current' | 'Historical';
  name: string;
  years: number | null;
  flavor: string;
  lockedName: boolean;
  lockedYears: boolean;
}

export interface WizardState {
  currentStep: WizardStep;
  aiMode: AiGenerationMode | null;
  // Step 2
  userNotes: string;
  // Map settings
  mapId: string;
  mapName: string;
  mapGenre: string;
  mapIdPreset: boolean;
  mapFile: File | null;
  mapJson: any | null;
  jsonFile: File | null;
  // Prefilled helper fields
  wcreditBalance: number;
  minYearsRequired: number;
  currentEra: { name: string; year: number; short: string } | null;
  // Step 4
  resourceConfig: {
    farmed: number;
    natural: number;
    bonus: number;
    mineral: number;
    special: number;
  };
  // Step 6
  worldIdentity: {
    eras: WorldEra[];
  };
  // Step 7
  globalContext: {
    description: string;
    primaryThemes: string;
    creationType: string;
    socialHierarchy: string;
    currencyType: string;
    technologyLevel: string;
    creationStory: string;
    uniqueFeatures: string;
    customsHolidays: string;
    techInnovations: string;
    recentEvents: string;
    politicalOverview: string;
    globalConflicts: string;
    prominentGuilds: string;
    guildDensity: string;
    guildCulture: string;
    guildVolatility: string;
  };
  // Steps 8-11
  cultureChaosLevel: string;
  cultures: any[];
  religionChaosLevel: string;
  religions: any[];
  stateChaosLevel: string;
  states: any[];
  provinceChaosLevel: string;
  provinces: any[];
  // Creation status & background flags
  creationStatus?: string;
  isBackgroundProcessing?: boolean;
  isUploadInProgress?: boolean;
}

export const initialWizardState: WizardState = {
  currentStep: WizardStep.Welcome,
  aiMode: null,
  userNotes: '',
  mapId: '',
  mapName: '',
  mapGenre: '',
  mapIdPreset: false,
  mapFile: null,
  mapJson: null,
  jsonFile: null,
  wcreditBalance: 0,
  minYearsRequired: 1000,
  currentEra: null,
  resourceConfig: {
    farmed: 5,
    natural: 5,
    bonus: 5,
    mineral: 5,
    special: 5
  },
  worldIdentity: { eras: [] },
  globalContext: {
    description: '',
    primaryThemes: '',
    creationType: '',
    socialHierarchy: '',
    currencyType: '',
    technologyLevel: '',
    creationStory: '',
    uniqueFeatures: '',
    customsHolidays: '',
    techInnovations: '',
    recentEvents: '',
    politicalOverview: '',
    globalConflicts: '',
    prominentGuilds: '',
    guildDensity: '',
    guildCulture: '',
    guildVolatility: ''
  },
  cultureChaosLevel: '',
  cultures: [],
  religionChaosLevel: '',
  religions: [],
  stateChaosLevel: '',
  states: [],
  provinceChaosLevel: '',
  provinces: [],
  creationStatus: '',
  isBackgroundProcessing: false,
  isUploadInProgress: false
};
